export default __webpack_public_path__ + "static/media/tick.657103ea.svg";